import { Text, TextButton, TextList, TextListItem } from '@oneaudi/unified-web-components';
import { Dialog } from '~/components/dialog';

export function UnauthenticatedDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
	return (
		<Dialog open={open} onCloseButtonClick={onClose}>
			<div className="flex flex-col gap-16 p-12">
				<Text variant={{ type: 'copy', order: '2', style: 'bold' }}>
					Melden Sie sich an um Ihre Konfiguration zu speichern.
				</Text>

				<TextList size="md" variant="bullet">
					<TextListItem>Sehen Sie sich Ihre gespeicherten Konfigurationen an</TextListItem>
					<TextListItem>
						Sie können jederzeit auf Ihre gespeicherten Konfigurationen zugreifen und diese bearbeiten
					</TextListItem>
					<TextListItem>Erhalten Sie persönliche Angebote von Ihrem Audi Partner</TextListItem>
				</TextList>

				<div className="grid grid-cols-2 gap-2">
					<TextButton size="md" variant="primary" onClick={() => {}}>
						Anmelden
					</TextButton>
					<TextButton size="md" variant={'secondary'} onClick={() => {}}>
						Registrieren
					</TextButton>
				</div>
			</div>
		</Dialog>
	);
}
